import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';
import { CampaignStatus } from '@/services/types';

interface CampaignStatusContextType {
  campaignStatus: CampaignStatus | null;
  setCampaignStatus: (status: CampaignStatus | null) => void;
  getFeatureStatus: (key: string) => number | undefined;
  bannerClosed: boolean;
  closeBanner: () => void;
}

const CampaignStatusContext = createContext<CampaignStatusContextType | undefined>(undefined);

interface CampaignStatusProviderProps {
  children: ReactNode;
}

export const CampaignStatusProvider: React.FC<CampaignStatusProviderProps> = ({ children }) => {
  const [campaignStatus, setCampaignStatus] = useState<CampaignStatus | null>(null);
  const [bannerClosed, setBannerClosed] = useState(false);

  const getFeatureStatus = useCallback(
    (key: string): number | undefined => {
      return campaignStatus?.[key]?.status;
    },
    [campaignStatus]
  );

  const closeBanner = useCallback(() => {
    setBannerClosed(true);
  }, []);

  return (
    <CampaignStatusContext.Provider
      value={{ campaignStatus, setCampaignStatus, getFeatureStatus, bannerClosed, closeBanner }}
    >
      {children}
    </CampaignStatusContext.Provider>
  );
};

export const useCampaignStatus = (): CampaignStatusContextType => {
  const context = useContext(CampaignStatusContext);
  if (!context) {
    throw new Error('useCampaignStatus 必须在 CampaignStatusProvider 内使用');
  }
  return context;
};
